import React, { FC } from 'react';

import HighlightText from '@adsk/alloy-react-highlight-text';
import theme from '@adsk/alloy-react-theme';

type HighlightedItemTextProps = {
  text: string;
  search?: string;
  highlighted?: boolean;
};

const HighlightedItemText: FC<HighlightedItemTextProps> = ({
  text,
  search,
  highlighted,
}) => {
  return (
    <HighlightText
      text={text}
      matched={search}
      highlightStyle={
        highlighted
          ? {
              backgroundColor: theme.colors.adskBlue100,
              color: theme.colors.black,
            }
          : undefined
      }
    />
  );
};

HighlightedItemText.displayName = 'HighlightedItemText';

export default HighlightedItemText;
